// O painel dedicado de um recurso de IA da área de trabalho de desembolso (planning-workspace):
// um diálogo lateral que existe só enquanto aberto — fechar é desmontar, então nada do
// rascunho sobrevive — e que fecha com Escape ou pelo botão. Quem o monta (a tela) decide
// quando ele existe: nunca em modo apresentação, nunca depois da troca de obra.
//
// O painel de organização do módulo Ampli (`OrganizeWithAiPanel`) já tem esta forma; este é
// o mesmo molde para o recurso da tela legada (o composer de antecipação).
import { useEffect, useId, useRef } from "react";

const AiPanel = ({ title, onClose, children, className = "" }) => {
  const panelRef = useRef(null);
  const titleId = useId();

  useEffect(() => {
    const previousFocus = document.activeElement;
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        onClose?.();
        return;
      }
      if (event.key !== "Tab" || !panelRef.current) return;
      const focusable = [
        ...panelRef.current.querySelectorAll(
          'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [href], [tabindex]:not([tabindex="-1"])',
        ),
      ];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    panelRef.current?.focus();
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      previousFocus?.focus?.();
    };
  }, [onClose]);

  return (
    <div className="offcanvas active">
      <section
        className={`offcanvas-container disbursement-ai-panel ${className}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        ref={panelRef}
      >
        <header className="offcanvas-header">
          <h2 id={titleId}>{title}</h2>
          <button
            type="button"
            className="disbursement-ai-panel__close"
            aria-label="Fechar"
            title={`Fechar ${title.toLocaleLowerCase("pt-BR")}`}
            onClick={() => onClose?.()}
          >
            <span aria-hidden="true">×</span>
          </button>
        </header>
        <div className="offcanvas-content">{children}</div>
      </section>
    </div>
  );
};

export default AiPanel;
